export interface Container {
  nestingLevel: number;
  id?: string;
}

export interface Nestable {
  parent?: Container;
  level: number;
}

export function nestableLevel(n: Nestable): number {
  return n.parent ? n.parent.nestingLevel + 1 : 0;
}

export function indent(level: number): string {
  return '    '.repeat(level);
}
